<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Mimbo</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/home']"
        ><ion-icon name="menu-outline" slot="icon-only"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <app-post-card
      [post]="post"
      [userId]="userId"
      [posts]="[post]"
    ></app-post-card>
  </div>
</ion-content>
